/* globals FWP, strl_vars, Foundation */

function rebuildPagination() {
	const FWP = window.FWP;
	const paginationWrappers = document.querySelectorAll('.pagination');

	if (FWP.loaded && paginationWrappers) {
		paginationWrappers.forEach((pagination) => {
			const totalPages = FWP.settings.pager.total_pages;
			const currentPage = FWP.settings.pager.page;
			const translateOf = strl_vars.translate_of;

			if ( totalPages > 1 ) {
				const facetPageWrapper = pagination.querySelector('.facetwp-pager');
				const pages = facetPageWrapper.querySelectorAll('.facetwp-page:not(.prev):not(.next)');
				const prevPage = facetPageWrapper.querySelector('.prev');
				const nextPage = facetPageWrapper.querySelector('.next');

				const fractionHTML = document.createElement('span');
				fractionHTML.classList.add('page-total');
				fractionHTML.innerHTML = currentPage + ' ' + translateOf + ' ' + totalPages;
				const fraction = facetPageWrapper.querySelector('.page-total');

				pagination.style.display = 'block';

				if ( prevPage ) {
					prevPage.style.display = 'flex';
				}

				if ( nextPage ) {
					nextPage.style.display = 'flex';
				}

				pages.forEach((page) => { page.style.display = 'none'; });
				if ( currentPage === 1 && facetPageWrapper) {
					facetPageWrapper.insertBefore(fractionHTML, nextPage);
				} else if ( ! fraction && facetPageWrapper) {
					facetPageWrapper.insertBefore(fractionHTML, prevPage.nextElementSibling);
				}
			} else {
				pagination.style.display = 'block';
			}
		})
	}
}

setTimeout(() => {
	rebuildPagination();

	document.addEventListener('facetwp-loaded', () => {
		rebuildPagination();
	});
}, 100);
